import _ from 'lodash';
import {parseGetParams, getURLParams} from 'utils/urls';

export const SORT_NONE: 'none' = 'none';
export const SORT_ASCENDING: '+' = '+';
export const SORT_DESCENDING: '-' = '-';

export const DEFAULT_SORT_DIRECTION = SORT_DESCENDING;

const SORT_STATES_NEXT_DIRECTION_MAPPING = {
  [SORT_NONE]: SORT_DESCENDING,
  [SORT_DESCENDING]: SORT_ASCENDING,
  [SORT_ASCENDING]: SORT_NONE
};

export const EMPTY_SORT_OBJECT = {
  field: null,
  direction: SORT_NONE
};

type SortForUrl = {orderBy?: string};
export type SortForStore = {
  field: string | null;
  direction: '+' | '-' | 'none';
};

export const getNextDirectionSort = (
  newSortField: string,
  sortForStore: SortForStore
): SortForStore => {
  // Set first direction if the field was not being sorted before
  if (newSortField !== sortForStore.field) {
    return {
      field: newSortField,
      direction: DEFAULT_SORT_DIRECTION
    };
  }

  const newSortDirection =
    SORT_STATES_NEXT_DIRECTION_MAPPING[sortForStore.direction];

  // Unset field if we are back to the starting point
  if (newSortDirection === SORT_NONE) {
    return EMPTY_SORT_OBJECT;
  }

  return {
    field: newSortField,
    direction: newSortDirection
  };
};

/*
SortForUrl -> SortForStore
*/
export const transformSortForUrlToSortForStore = (
  urlSortObj: SortForUrl
): SortForStore => {
  if (_.isNil(urlSortObj['orderBy'])) {
    return EMPTY_SORT_OBJECT;
  }

  const orderByParam: string = urlSortObj['orderBy'];

  if (orderByParam.startsWith('-')) {
    return {
      field: orderByParam.substr(1), // detach the sign
      direction: SORT_DESCENDING
    };
  }

  return {
    field: orderByParam,
    direction: SORT_ASCENDING
  };
};

export const transformSortForStoreToSortForUrl = (
  storeSort: SortForStore
): SortForUrl => {
  if (_.isNull(storeSort.field)) {
    return {orderBy: undefined};
  }

  // Field needs to be snake case because it is sent as a "string" that is a value
  // and the backend doesn't expect it to be a field name
  const field = _.snakeCase(storeSort.field);
  const prefix = storeSort.direction === SORT_DESCENDING ? '-' : '';

  return {orderBy: `${prefix}${field}`};
};

export const getSortFromUrl = (): SortForStore => {
  const pageParams = parseGetParams(getURLParams());

  return transformSortForUrlToSortForStore(pageParams);
};
